<div [ngClass]="{ grow: !showAddButton() }">
  <div class="bold">{{ evidence.evidenceDescription }}</div>

  @if (!evidence.evidenceValue.length) {
    <div>(empty)</div>
  }

  @for (evidenceValue of evidence.evidenceValue; track $index) {
    <div class="evidence-value-row">
      <display-data
        [value]="evidenceValue"
        [showAllFields]="showAllFields"
        [dataType]="evidence.attributeUiType || evidence.evidenceType"
      ></display-data>
      @if (evidence.attributeUiType === 'Document') {
        <button
          mat-icon-button
          aria-label="Download button"
          (click)="openEvidenceImageInS3(evidenceValue, evidence)"
        >
          <mat-icon class="download-icon">download</mat-icon>
        </button>
      }
    </div>
  }
</div>
<app-custom-field-editor-modal></app-custom-field-editor-modal>

@if (showAddButton()) {
  <button
    class="add-button"
    mat-button
    aria-label="Click to Add"
    (click)="openEditAttributeModal()"
  >
    Click to Add
  </button>
}
@if (showEditButton()) {
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    aria-label="Custom Fields actions"
  >
    <mat-icon>more_vert</mat-icon>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="openEditAttributeModal()">
        Edit Field
      </button>
      @if (evidence.attributeUiType !== 'Document') {
        <button mat-menu-item (click)="onClearField()">Clear Field</button>
      }
    </mat-menu>
  </button>
}
